const fmt = (n: number) =>
  new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    maximumFractionDigits: 0,
  }).format(n);

/** Short cause line for breakdown alerts (one sentence). */
export const PDL_ADJUDICATOR_DECLINE_CAUSE: Record<string, string> = {
  ZERO_INCOME: 'No verified monthly income from the bank feed.',
  PDL_INCOME_MISSING: 'Income snapshot was missing when capacity was evaluated.',
  JURISDICTION_BLOCKED: 'Payday lending is not offered in this province or territory.',
  INTERNAL_C4Y_LOAN:
    'Recurring Cash4You loan payments were detected on the connected bank account (ELOD hard stop).',
  PAYDAY_STACKING: 'Six or more active payday lenders were detected on the bank account.',
  OVER_TDS: 'Existing debt leaves less than the $100 product minimum in payment room.',
  BLOCKED_EMPLOYER: 'Employer matched the Cash4You blocklist.',
  BLOCKED_INCOME_TYPE: 'Income type is not eligible for payday under policy.',
  PAST_DUE: 'Prior payday loan shows a past-due balance in servicing records.',
  UNDER_AGE: 'Applicant is under 18.',
};

/** Structured hard-stop block for the full breakdown dialog. */
export function buildPdlHardStopBreakdown(input: {
  declineReason: string;
  tableLimit?: number | null;
}): { title: string; lines: string[] } {
  const key = input.declineReason.trim().toUpperCase();
  const cause =
    PDL_ADJUDICATOR_DECLINE_CAUSE[key] ??
    input.declineReason.replace(/_/g, ' ').toLowerCase();

  const lines = [cause];
  if (input.tableLimit != null && input.tableLimit > 0) {
    lines.push(
      `Pre-approval table would have capped at ${fmt(input.tableLimit)} before this hard stop.`,
    );
  }
  lines.push('No payday principal is issued while this stop is active.');

  return {
    title: 'Hard stop — no offer issued',
    lines,
  };
}
